export default "__VITE_ASSET__CdVNgUix__"